import { useEffect, useState } from "react";
import { businessInfo } from "@/mocks/home";

export default function FloatingContact() {
  const [visible, setVisible] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 320);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const actions = [
    {
      key: "call",
      href: businessInfo.phoneLink,
      label: `Llamar al ${businessInfo.phoneDisplay}`,
      icon: "ri-phone-fill",
      external: false,
      bgClass: "bg-primary-600",
      ringClass: "bg-primary-500/40",
      textClass: "text-background-50",
      ping: false,
    },
    {
      key: "whatsapp",
      href: businessInfo.whatsappLink,
      label: "Escríbenos por WhatsApp",
      icon: "ri-whatsapp-fill",
      external: true,
      bgClass: "bg-[#25D366]",
      ringClass: "bg-[#25D366]/40",
      textClass: "text-white",
      ping: true,
    },
  ];

  return (
    <div
      className={`fixed z-50 right-4 md:right-6 bottom-4 md:bottom-6 flex flex-col items-end gap-3 transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-6 pointer-events-none"
      }`}
      aria-label="Contacto rápido"
    >
      <div
        className={`flex flex-col items-end gap-3 origin-bottom-right transition-all duration-300 ${
          expanded ? "opacity-100 scale-100 pointer-events-auto" : "opacity-0 scale-90 pointer-events-none md:opacity-100 md:scale-100 md:pointer-events-auto"
        }`}
      >
        {actions.map((action) => (
          <a
            key={action.key}
            href={action.href}
            target={action.external ? "_blank" : undefined}
            rel={action.external ? "noreferrer" : undefined}
            aria-label={action.label}
            onClick={() => setExpanded(false)}
            className="group relative flex items-center cursor-pointer"
          >
            <span className="mr-3 hidden md:block max-w-0 overflow-hidden whitespace-nowrap rounded-full bg-foreground-950 text-background-50 text-xs font-semibold py-2 opacity-0 transition-all duration-300 group-hover:max-w-[220px] group-hover:px-4 group-hover:opacity-100">
              {action.label}
            </span>
            <span className="relative w-12 h-12 md:w-14 md:h-14 flex items-center justify-center">
              {action.ping && (
                <span
                  className={`absolute inset-0 rounded-full ${action.ringClass} animate-ping opacity-60`}
                  aria-hidden="true"
                ></span>
              )}
              <span
                className={`relative w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full ${action.bgClass} ${action.textClass} shadow-lg transition-transform duration-300 group-hover:scale-105`}
              >
                <i className={`${action.icon} text-2xl md:text-3xl`}></i>
              </span>
            </span>
          </a>
        ))}
      </div>

      {/* Mobile toggle */}
      <button
        type="button"
        onClick={() => setExpanded((prev) => !prev)}
        aria-label={expanded ? "Cerrar opciones de contacto" : "Ver opciones de contacto"}
        aria-expanded={expanded}
        className="md:hidden w-14 h-14 flex items-center justify-center rounded-full bg-primary-600 text-background-50 shadow-lg cursor-pointer transition-transform duration-300 active:scale-95"
      >
        <i className={`${expanded ? "ri-close-line" : "ri-customer-service-2-line"} text-2xl`}></i>
      </button>
    </div>
  );
}